<template>
  <div class="custom-checkbox">
    <input type="text" v-model="checkedValue" @input="handleChange" maxlength="1">
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checkedValue: this.value // Initially unchecked
    };
  },
  methods: {
    handleChange() {
      // Ensure the input is either "x" or "-"
      if (this.checkedValue !== 'x' && this.checkedValue !== '/' && this.checkedValue !== '*') {
        this.checkedValue = ''; // Reset to empty if input is invalid
      }
      this.$emit('input', this.checkedValue); // Emit input event with updated value
    }
  }
}
</script>

<style>
.custom-checkbox {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  text-align: center;
  line-height: 20px;
  margin-right: 10px; /* Add margin between checkboxes */
}

.custom-checkbox input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  font-size: 20px; /* Match the font size to the width and height of the box */
}
</style>
